import Modal from "../Modal";
import {
  Checkbox,
  Content,
  Header,
  HeaderTitle,
  IconWrapper,
  Inner,
  Item,
  SpinnerWrapper,
  Title,
  Wrapper,
} from "./SwitchLanguageModal.styles";
import { useTranslation } from "react-i18next";
import { CheckOutlined, GlobeOutlined, SearchOutlined } from "@gds-react/icons";
import { useStore } from "../../store/store";
import useCoreContext from "@gf-core/widgets/hooks/useCoreContext";
import { Icon, TextField } from "@gds-react/core";
import { useLanguageList } from "../../hooks/useLanguageList";
import Spinner from "../Spinner";
import { Language } from "../../generated-api/account";
import { getEmoji } from "language-flag-colors";
import { useMemo, useState } from "react";

interface Props {
  show?: boolean;
  onClose?: () => void;
}

/** Widget used for creating a virtual device */
export default function SwitchLanguageModal({ show = false, onClose }: Props) {
  const { t } = useTranslation();
  const setLanguage = useStore.useSetLanguageSettings();
  const language = useStore.useLanguageSettings();
  const { setLocale, theme } = useCoreContext();
  const { data, isLoading } = useLanguageList();
  const [q, setQ] = useState("");

  const onChangeLanguage = (langCode: Language) => {
    setLanguage(langCode);
    setLocale(langCode.iso639Code);
    onClose && onClose();
  };

  const list = useMemo(() => {
    return (
      data?.model.filter((lang) => {
        return lang.languageName.toLowerCase().includes(q.toLowerCase());
      }) ?? []
    );
  }, [data, q]);

  return (
    <Modal open={show} onClose={onClose} maxWidth={600}>
      <Header>
        <HeaderTitle>{t("switchLanguageModal.title")}</HeaderTitle>
      </Header>
      <Wrapper>
        <TextField
          onChange={(e) => setQ(e.target.value)}
          value={q}
          size="large"
          placeholder={t("switchLanguageModal.placeholder")}
          prefixIcon={<Icon src={<SearchOutlined />} />}
        />
        {isLoading && (
          <SpinnerWrapper>
            <Spinner color={theme.core.colors.text.primary.color} />
          </SpinnerWrapper>
        )}
        <Inner>
          {!isLoading &&
            list.map((lang, index) => {
              const flag =
                getEmoji(lang.iso639Code) ?? getEmoji(lang.languageName);
              return (
                <Item
                  key={index}
                  onClick={() => lang.iso639Code && onChangeLanguage(lang)}
                >
                  <IconWrapper>
                    {flag ? (
                      flag
                    ) : (
                      <GlobeOutlined style={{ width: 18, height: 18 }} />
                    )}
                  </IconWrapper>
                  <Content>
                    <Title>{lang.languageName}</Title>
                  </Content>
                  <Checkbox checked={language.iso639Code === lang.iso639Code}>
                    {language.iso639Code === lang.iso639Code && (
                      <CheckOutlined style={{ width: 18, height: 18 }} />
                    )}
                  </Checkbox>
                </Item>
              );
            })}
        </Inner>
      </Wrapper>
    </Modal>
  );
}
